import { render, staticRenderFns } from "./deal-create-selection.vue?vue&type=template&id=39670f4a"
import script from "./deal-create-selection.vue?vue&type=script&lang=js"
export * from "./deal-create-selection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports